import type { SVGAttributes } from "react"

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return <img src="/alfred.png" alt="Alfred" className="h-full w-full" />
}
